/**
 * CinematicScene — envuelve una sección para darle una transición
 * cinemática (fade + subtle lift + micro-scale + tenue blur) usando
 * `animation-timeline: view()` cuando el navegador lo soporta.
 *
 * Fallback: sin animación (contenido visible normal). Respeta
 * `prefers-reduced-motion`. No secuestra el scroll — solo pinta el
 * borde de entrada/salida de cada sección para que se sientan como
 * "escenas" en lugar de bloques planos.
 */
export default function CinematicScene({
  children,
  as: Tag = "div",
  intensity = "standard", // "subtle" | "standard" | "strong"
  className = "",
  ...rest
}) {
  return (
    <Tag
      className={`cinematic-scene cinematic-scene--${intensity} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}
